import { Box, Typography } from '@mui/material';
import ArieteIcon from '@/components/shared/icons/recommendation-icons/ariete-icon';
import MissedPenaltiIcon from '@/components/shared/icons/recommendation-icons/missed-penalti-icon';
import OwnGoalsIcon from '@/components/shared/icons/recommendation-icons/own-goals-icon';
import AsistenciasIcon from '@/components/shared/icons/tarjetas/asistencias-icon';
import VarIcon from './VarIcon';

const getFixtureEvent = (type, detail, isRemoved, width) => {
    switch (type?.toLowerCase()) {
        case 'goal':
            if (detail === 'Own Goal') return { mainIcon: <OwnGoalsIcon width={width} />, secondIcon: null };
            if (detail === 'Missed Penalty')
                return { mainIcon: <MissedPenaltiIcon width={width} />, secondIcon: null };
            return {
                mainIcon: <ArieteIcon width={width} />,
                secondIcon: <AsistenciasIcon width={width} />,
            };

        case 'card':
            if (detail === 'Red Card')
                return {
                    mainIcon: isRemoved ? (
                        <Box
                            sx={{
                                background: 'rgb(225, 29, 72)',
                                color: '#fff',
                                borderRadius: '4px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '12px',
                            }}
                            width={width}
                        >
                            X
                        </Box>
                    ) : (
                        <Box
                            sx={{
                                background: 'rgb(156, 23, 23)',
                                borderRadius: '2px',
                            }}
                            width={width}
                            height={width * 1.5}
                        />
                    ),
                    secondIcon: null,
                };
            return {
                mainIcon: isRemoved ? (
                    <Box
                        sx={{
                            background: '#fedd26',
                            color: '#fff',
                            borderRadius: '4px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '12px',
                        }}
                        width={width}
                    >
                        X
                    </Box>
                ) : (
                    <Box
                        sx={{
                            background: '#fedd26',
                            borderRadius: '2px',
                        }}
                        width={width}
                        height={width * 1.5}
                    />
                ),
                secondIcon: null,
            };

        case 'subst':
            return {
                mainIcon: (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={width * 1.2}
                        height={width * 1.2}
                        viewBox="0 0 24 24"
                    >
                        <path fill="#059669" d="M15 20H9v-8H4.16L12 4.16L19.84 12H15v8Z" />
                    </svg>
                ),
                secondIcon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={width} viewBox="0 0 24 24">
                        <path fill="#e11d48" d="M9 4h6v8h4.84L12 19.84L4.16 12H9V4Z" />
                    </svg>
                ),
            };

        case 'var':
            return {
                mainIcon: <VarIcon />,
                secondIcon: null,
            };

        default:
            return { mainIcon: null, secondIcon: null };
    }
};

const JugadoresEventoPartido = ({ type, detail, entity, minute, isRemoved, isTitular, width = 14 }) => {
    const { mainIcon, secondIcon } = getFixtureEvent(type, detail, isRemoved, width);

    return (
        <Box display="flex" alignItems="center" gap={0.2}>
            {type === 'subst' && (isTitular ? secondIcon : mainIcon)}
            {type !== 'subst' && (entity === 'p' ? mainIcon : secondIcon)}
            {minute && <Typography fontSize={10}>{minute}'</Typography>}
        </Box>
    );
};

export default JugadoresEventoPartido;
